import { AxiosRequestHeaders } from "axios";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useStyleContext } from "../../../helpers/StyleContext";
import clsx from "clsx";

type Props = {
  pagination: {
    page: number;
    amount: number;
    itemsFound: number;
    total: number;
  };
  loadList: (module: string, headers: AxiosRequestHeaders) => Promise<void>;
  module: string;
  descriptionModule?: string;
  findHeaders: {
    Authorization: string;
    operation: string;
  };
  filters: {
    status: string;
    search?: string;
  };
  pageFilter: boolean;
  situationFilter: boolean;
};

export function DropdownFilterTables({
  pagination,
  loadList,
  module,
  findHeaders,
  filters,
  pageFilter,
  situationFilter,
}: Props) {
  const [selectedAmount, setSelectedAmount] = useState<number>(5);
  const [searchString, setSearchString] = useState<string>("");
  const [selectedFilters, setSelectedFilters] = useState({
    status: "all",
  });
  const [disabledSearchButton, setDisabledSearchButton] = useState(false);
  const [disabledResetButton, setDisabledResetButton] = useState(false);
  const url = useLocation();
  const filterCharges = url.pathname.includes("charges");
  const filterContracts = url.pathname.includes("contracts");
  const endsWithUsers = url.pathname.endsWith("users");
  const { styleState } = useStyleContext();

  const Paginate = () => {
    setDisabledSearchButton(true);

    pagination.amount = selectedAmount;
    pagination.page = 1;

    filters.status = selectedFilters.status;
    filters.search = searchString;

    loadList(module, findHeaders);

    setTimeout(() => {
      setDisabledSearchButton(false);
    }, 500);
  };

  const ResetFilters = () => {
    setDisabledResetButton(true);
    setSelectedAmount(5);
    setSearchString("");
    setSelectedFilters({
      status: "all",
    });

    pagination.amount = 5;
    pagination.page = 1;

    filters.status = "all";
    filters.search = "";

    loadList(module, findHeaders);

    setTimeout(() => {
      setDisabledResetButton(false);
    }, 500);
  };

  return (
    <div
      className="menu menu-sub menu-sub-dropdown w-250px w-md-300px"
      data-kt-menu="true"
      style={{
        backgroundColor: styleState?.secondary_text_color,
        color: styleState?.secondary_color,
      }}
    >
      <div className="px-7 py-5">
        <div
          className={clsx("fs-5 fw-bolder", {
            "text-dark": !styleState.secondary_color,
          })}
          style={{
            color: styleState?.secondary_color,
          }}
        >
          Filtros
        </div>
      </div>
      <div className="separator border-gray-200"></div>
      <div className="px-7 py-5">
        {endsWithUsers && (
          <div className="mb-5">
            <label
              className="form-label fw-bold"
              style={{
                color: styleState?.secondary_color,
              }}
            >
              Pesquisa:
            </label>
            <div>
              <div className="d-flex align-items-center position-relative my-1">
                <input
                  type="text"
                  className="form-control form-control-solid w-250px"
                  placeholder=""
                  value={searchString}
                  onChange={(event) => setSearchString(event.target.value)}
                />
              </div>
            </div>
          </div>
        )}
        {situationFilter && (
          <div className="mb-5">
            <label
              className="form-label fw-bold"
              style={{
                color: styleState?.secondary_color,
              }}
            >
              Situação:
            </label>
            <div>
              {filterCharges ? (
                <select
                  className="form-select form-select-solid"
                  data-kt-select2="true"
                  data-placeholder="Select option"
                  data-allow-clear="true"
                  value={selectedFilters.status}
                  onChange={(event) =>
                    setSelectedFilters({ status: event?.target?.value })
                  }
                >
                  <option value="all">Todos</option>
                  <option value="overdue">Atrasado</option>
                  <option value="paid">Pago</option>
                  <option value="opened">Em aberto</option>
                  <option value="canceled">Cancelado</option>
                </select>
              ) : filterContracts ? (
                <select
                  className="form-select form-select-solid"
                  data-kt-select2="true"
                  data-placeholder="Select option"
                  data-allow-clear="true"
                  value={selectedFilters.status}
                  onChange={(event) =>
                    setSelectedFilters({ status: event?.target?.value })
                  }
                >
                  <option value="all">Todos</option>
                  <option value="pending">Pendentes</option>
                  <option value="current">Vigentes</option>
                  <option value="suspended">Suspensos</option>
                  <option value="expired">Expirados</option>
                  <option value="terminated">Encerrados</option>
                  <option value="void">Inválidos</option>
                </select>
              ) : (
                <select
                  className="form-select form-select-solid"
                  data-kt-select2="true"
                  data-placeholder="Select option"
                  data-allow-clear="true"
                  value={selectedFilters.status}
                  onChange={(event) =>
                    setSelectedFilters({ status: event?.target?.value })
                  }
                >
                  <option value="all">Todos</option>
                  <option value="available">Disponíveis</option>
                  <option value="unavailable">Indisponíveis</option>
                </select>
              )}
            </div>
          </div>
        )}
        {pageFilter && (
          <div className="mb-5">
            <label
              className="form-label fw-bold"
              style={{
                color: styleState?.secondary_color,
              }}
            >
              Itens por página:
            </label>
            <div>
              <select
                className="form-select form-select-solid"
                data-kt-select2="true"
                data-placeholder="Select option"
                data-allow-clear="true"
                value={selectedAmount}
                onChange={(event) =>
                  setSelectedAmount(parseInt(event?.target?.value))
                }
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="15">15</option>
                <option value="20">20</option>
                <option value="25">25</option>
                <option value="30">30</option>
                <option value="40">40</option>
                <option value="50">50</option>
              </select>
            </div>
          </div>
        )}
        <div className="d-flex justify-content-end">
          <button
            type="submit"
            className="btn btn-sm btn-primary me-2"
            data-kt-menu-dismiss="true"
            onClick={(event) => {
              event.preventDefault();
              Paginate();
            }}
            disabled={disabledSearchButton}
          >
            <span style={{ display: disabledSearchButton ? "none" : "block" }}>
              Aplicar
            </span>
            <span
              className="indicator-progress"
              style={{ display: disabledSearchButton ? "block" : "none" }}
            >
              Aplicando...
              <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
          </button>
          <button
            type="reset"
            className="btn btn-sm btn-light btn-active-light-primary"
            data-kt-menu-dismiss="true"
            onClick={(event) => {
              event.preventDefault();
              ResetFilters();
            }}
            disabled={disabledResetButton}
          >
            <span style={{ display: disabledResetButton ? "none" : "block" }}>
              Resetar
            </span>
            <span
              className="indicator-progress"
              style={{ display: disabledResetButton ? "block" : "none" }}
            >
              Resetando...
              <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}
